import type { ExpenseBudgetItemQuery } from "@src/__generated__/graphql";
import { action, makeObservable, observable } from "mobx";

type TExpenseItem = NonNullable<ExpenseBudgetItemQuery["expenseBudgetItem"]>;

export class ExpenseItem {
  id: TExpenseItem["id"];
  type: TExpenseItem["type"];
  title: TExpenseItem["title"];
  @observable.ref completed_at: TExpenseItem["completed_at"];
  project: TExpenseItem["project"];
  expenseStats: TExpenseItem["expenseStats"];
  @observable.ref stats: TExpenseItem["stats"];

  constructor(src: TExpenseItem) {
    makeObservable(this);
    this.id = src.id;
    this.type = src.type;
    this.title = src.title;
    this.completed_at = src.completed_at;
    this.project = src.project;
    this.expenseStats = src.expenseStats;
    this.stats = src.stats;
  }

  @action
  setCompletedAt(value: TExpenseItem["completed_at"]) {
    this.completed_at = value;
  }

  @action
  updateStats(stats: Omit<TExpenseItem["stats"], "real_expenses">) {
    this.stats = { ...this.stats, ...stats };
  }
}
